import { map, pick } from 'lodash-es'

const transformMenuTitle = values => pick(values, 'id', 'isEverywhereAvailable')

const transformUploadedMenuTitle = values =>
  pick(
    values,
    'id',
    'parentId',
    'title',
    'description',
    'diets',
    'addons',
    'miscInfo',
    'allergens',
    'nutritions',
    'calories',
  )

const transformUploadedDish = values =>
  pick(
    values,
    'id',
    'menuTitleId',
    'name',
    'description',
    'ingredients',
    'price',
    'diets',
    'addons',
    'miscInfo',
    'allergens',
    'nutritions',
    'calories',
  )

const transformToDishReviewTaskInput = values => {
  const { task, menu, menuTitles, uploadedMenuData } = values

  const menuId = menu.id

  const result = {
    id: task.id,
    menuId,
  }

  if (
    uploadedMenuData &&
    uploadedMenuData.menuTitles &&
    uploadedMenuData.dishes
  ) {
    result.menuTitlesData = map(uploadedMenuData.menuTitles, transformMenuTitle)
    result.uploadedMenuTitlesData = map(
      uploadedMenuData.menuTitles,
      transformUploadedMenuTitle,
    )
    result.uploadedDishesData = map(
      uploadedMenuData.dishes,
      transformUploadedDish,
    )
  } else {
    result.menuTitlesData = map(menuTitles, transformMenuTitle)
  }

  return result
}

export default transformToDishReviewTaskInput
